import {TranslateService} from '@ngx-translate/core';

import {LocalizationService} from '../../../../../shared/localization/localization.service';
import {Chart} from '../../key-metrics.interfaces';

import {Pie} from './pie';

export class Doughnut extends Pie {
  constructor(chart: Chart,
              translate: TranslateService,
              localization: LocalizationService) {
    super(chart, translate, localization);

    this.createCircleChart();
    this.series[0].radius = ['40%', '60%'];
  }

  public createLoadView(withTitle: boolean, withLabel: boolean): void {
    this.series[0].radius = ['30%', '50%'];
    super.createLoadView(withTitle, withLabel);
  }

  public resetChart(): void {
    this.series[0].radius = ['40%', '60%'];
    super.resetChart();
  }
}
